import * as types from './actionTypes';
import { api } from './api';

export function addressLookup(zipCode) {
	return api({
		types: [types.ADDRESS__LOOKUP_REQUEST, types.ADDRESS__LOOKUP_SUCCESS, types.ADDRESS__LOOKUP_FAILURE],
		uri: `/api/address/zipcode/${zipCode.toString()}`,
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
			},
		},
	});
}
